import { DesignSystem } from '@adornis/chemistry/elements/theming/design.js';

// colors found by https://coolors.co/

DesignSystem.prefix = 'tr';
DesignSystem.setTheme(
  'tripteron',
  DesignSystem.extendBase(
    {
      fontFamily: 'Albert Sans',
      fontFamilyHeading: 'Albert Sans',
      sizes: {
        borderRadius: '7px',
        borderRadiusSecondary: '4px',
        sidebarMinWidth: '256px',
      },
      baseFontSize: 17,
    },
    {
      accent: '#239fd5',
      tone: {
        subtle: '#3E3E3E',
        placeholder: '#555555',
        success: '#4CAF50',
        warning: '#FFC107',
        error: '#800000',

        // others
        snowWhite: '#FAFAFA',
        onyx: '#3E3E3E',
        black: '#000',
        lightGrey: '#d8d8d6',
        tooltipBackground: '#333',

        light_blue: '#2881BA',
        light_red: '#E94C3E',
        light_orange: '#E67F22',
        light_bronze: '#7c6e3f',
        light_grau: '#3E3E3E',
      },
    },
  ),
);
DesignSystem.useTheme('tripteron');
